import { render } from "./DeviceInfosModal.vue?vue&type=template&id=63041c1a&scoped=true&ts=true&lang=pug"
import script from "./DeviceInfosModal.vue?vue&type=script&lang=ts"
export * from "./DeviceInfosModal.vue?vue&type=script&lang=ts"

import "./DeviceInfosModal.vue?vue&type=style&index=0&id=63041c1a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63041c1a"]])

export default __exports__